<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import type { ActivityDetail } from "../lib/restful";

  interface Props {
    activityData: ActivityDetail | null;
  }

  let { activityData }: Props = $props();

  /** 格式化日期 yyyy-MM-dd HH:mm:ss → yyyy/M/d */
  function formatDate(dateStr: string | undefined): string {
    if (!dateStr) return "--";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
  }

  /** 活动状态：根据 status 判断 */
  function getStatusInfo(data: ActivityDetail | null): {
    label: string;
    cssClass: string;
    dotClass: string;
  } {
    if (!data)
      return {
        label: "",
        cssClass: "text-tips-color-tips",
        dotClass: "bg-tips-color-tips",
      };

    // status: 0-未开始 1-进行中 2-待开奖 3-已完成
    if (data.status === 0) {
      return {
        label: $t("status_not_started"),
        cssClass: "text-tips-color-tips",
        dotClass: "bg-tips-color-tips",
      };
    }
    if (data.status === 1) {
      return {
        label: $t("status_ongoing"),
        cssClass: "text-tips-color-success",
        dotClass: "bg-tips-color-success",
      };
    }
    if (data.status === 2) {
      return {
        label: $t("lottery_status_pending"),
        cssClass: "text-tips-color-blue",
        dotClass: "bg-divider-color-1",
      };
    }
    if (data.status === 3) {
      return {
        label: $t("status_ended"),
        cssClass: "text-tips-color-warning",
        dotClass: "bg-tips-color-warning",
      };
    }
    return {
      label: $t("status_not_started"),
      cssClass: "text-tips-color-tips",
      dotClass: "bg-tips-color-tips",
    };
  }

  let dateRange = $derived(
    `${formatDate(activityData?.activityFrom)}-${formatDate(activityData?.activityTo)}`,
  );
  let statusInfo = $derived(getStatusInfo(activityData));
  let subtitle = $derived(activityData?.activityDesc || "");
</script>

<div class="flex flex-col items-center px-[16px] py-[6px]" style="gap: 6px;">
  <!-- 时间 + 状态胶囊 -->
  {#if activityData}
    <div
      class="capsule-bar h-[36px] px-[16px] backdrop-blur-md inline-flex border-mask-gradient items-center justify-center rounded-[50px] bg-tips-color-tips-opacity-20 border-1 border-transparent"
      style="gap: 6px;"
    >
      <span class="text-[16px] leading-6 font-bold text-text-reverse1"
        >{dateRange}</span
      >
      <span
        class="flex items-center justify-center gap-[4px] text-[14px] font-medium bg-divider-color-1 px-[8px] h-[22px] rounded-[40px] {statusInfo.cssClass}"
      >
        <span
          class="inline-block h-[6px] w-[6px] rounded-[6px] {statusInfo.dotClass}"
        ></span>
        {statusInfo.label}
      </span>
    </div>
  {/if}

  <!-- 副标题/牌照号码 -->
  {#if subtitle}
    <p class="text-center text-[12px] text-text-reverse1 font-normal">
      {subtitle}
    </p>
  {/if}
</div>

<style>
  .capsule-bar {
    max-width: 90%;
  }
</style>
